import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2, AlertCircle, ArrowRight } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Public referral resolver: /r/:code
 * Increments the rep's hit counter, saves rep_id to localStorage, then
 * redirects to /register (or /submit-general) so the body shop can sign up.
 */
export default function ReferralResolver() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [err, setErr] = useState(null);
  const [rep, setRep] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/public/referral/${code}`)
      .then((r) => {
        setRep(r.data);
        localStorage.setItem("truline_referred_by", JSON.stringify({
          rep_id: r.data.rep_id,
          rep_name: r.data.rep_name,
          code,
          timestamp: Date.now(),
        }));
        // Small delay so user sees the greeting, then redirect to register
        setTimeout(() => navigate("/register"), 2200);
      })
      .catch((e) => setErr(e?.response?.data?.detail || "Link inválido ou expirado"));
  }, [code, navigate]);

  if (err) {
    return (
      <div className="min-h-screen bg-[#030712] text-slate-200 flex items-center justify-center p-6">
        <div className="max-w-md text-center">
          <AlertCircle className="w-12 h-12 text-rose-400 mx-auto mb-4" />
          <h1 className="font-display text-2xl text-rose-300 mb-2">Link inválido</h1>
          <p className="text-sm text-slate-400">{err}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#030712] text-slate-200 flex items-center justify-center p-6" data-testid="referral-resolver">
      <div className="max-w-md text-center">
        {rep ? (
          <>
            <div className="w-16 h-16 rounded-full bg-emerald-500/15 border-2 border-emerald-500 flex items-center justify-center mx-auto mb-6">
              <ArrowRight className="w-8 h-8 text-emerald-400" />
            </div>
            <h1 className="font-display text-3xl text-slate-100 mb-2">Bem-vindo!</h1>
            <p className="text-base text-slate-300 mb-1">
              Você foi indicado por <strong className="text-emerald-300" data-testid="referral-rep-name">{rep.rep_name}</strong>
            </p>
            <p className="text-sm text-slate-500 mb-6">de {rep.company_name}</p>
            <div className="rounded-lg border border-emerald-500/30 bg-emerald-500/5 p-4 mb-6">
              <p className="text-xs text-emerald-200 leading-relaxed">
                Levando você para o formulário de cadastro. Todas as suas negociações futuras ficam vinculadas ao seu consultor <strong>{rep.rep_name}</strong>.
              </p>
            </div>
            <Loader2 className="w-5 h-5 animate-spin text-emerald-400 mx-auto" />
          </>
        ) : (
          <Loader2 className="w-8 h-8 animate-spin text-blue-400 mx-auto" />
        )}
      </div>
    </div>
  );
}
